module.exports = __webpack_public_path__ + "static/media/app_store.2ab73e49.png";